
/* eslint-disable */
import { computed, defineComponent, onMounted, ref } from "vue";
import AlertConfiguration from "@/helpers/pages/AlertConfiguration";
import AgCard from "@/components/ag-card/index.vue";
import { useStore } from "@/store";
import { AlertActionTypes } from "@/store/modules/alert/action-types";
import { GeneralMutationTypes } from "@/store/modules/general/mutation-types";
import api from "@/store/axiosAgsc";
import AgLoading from "@/components/ag-loading/index.vue";
import Swal from "sweetalert2";
import Multiselect from "@vueform/multiselect";
import $ from "jquery";

export default defineComponent({
  name: "SecurityAlerts",
  components: { AgCard, AgLoading, Multiselect },
  computed: {
    currentConditions: {
      get: function () {
        let condition: any = this.categorylist.filter((i: any) => {
          return i.id == this.newAlertJson.selectedAlert;
        })[0];

        if (!condition || typeof condition === "undefined") {
          condition = this.categorylist[0]
        }

        if (this.isEditing()) {
          let row = this.getRow(this.newAlertJson.selectedAlert);
          condition = row;
        }

        if(condition && condition.emails) {
          this.emails = condition.emails
        }
   
        try {
          return JSON.parse(condition.conditionJson.replaceAll(/\n/g,""));
        } catch (error) {
          console.log(error);
          return false;
        }
      },
      set: function (value: any) {
        //console.log(value)
      },
    },
    emailList: {
      // getter
      get: function () {
        const store = useStore();
        let emails: any = this.emails;
        if (this.emails == null)
          return (
            store.state.auth.user.filter(
              (item) => item.type === "preferred_username"
            )[0]?.value || "X"
          );
        else return emails;
      },
      // setter
      set: function (newValue: any) {
        this.emails = newValue;
      },
    },
    currentCompanyGuid() {
      const store = useStore();
      return store.state.auth.company.companyGuid;
    },
    // currentConditions() {
    //   let condition = this.categorylist.filter((i) => {
    //     return i.id == this.newAlertJson.selectedAlert
    //   })[0];
    //   return (condition && condition.conditionJson ? JSON.parse(condition.conditionJson) : false);
    // }
  },
  mounted() {
    this.newAlertJson.selectedAlert = "";
    if (this.emails.length === 0) {
      const store = useStore();
      const userEmail = store.state.auth.user.filter(
        (item) => item.type === "preferred_username"
      )[0]?.value;
      if (userEmail) {
        this.emails.push(userEmail);
      }
    }
  },
  setup() {
    let currCondId = ref("");
    let loading = ref(true);
    let categorylist: any = ref([]);

    const newAlertJson = ref({
      selectedAlert: "",
    });

    const store = useStore();
    const module = ref(AlertConfiguration);
    const currCompanyGuid = store.state.auth.company.companyGuid;
    const getList = function () {
      setTimeout(() => {
        store
          .dispatch(AlertActionTypes.GET_ALARM_CONDITIONS, "")
          .then(async (response: any) => {
            const resp: any = await store.dispatch(
              AlertActionTypes.GET_ALERTCONDITION_CATS,
              1
            );

            categorylist.value = resp.entityData;
            if (categorylist.value[0] && categorylist.value[0].id) {
              newAlertJson.value.selectedAlert = categorylist.value[0].id;
              setTimeout(() => {
                try {
                  $('#target option:first').trigger('click'); 
                } catch (error) {
                  console.log(error)
                }
              }, 200);
            }
            response.entityData.securityAlarmConditions.map((item: any) => {
              let alarmCateogryLabel: any = categorylist.value.filter(
                (cat: any) => {
                  if (cat.id == item.alarmCateogryGuid) {
                  }
                  return cat.id == item.alarmCateogryGuid;
                }
              )[0];

              if (alarmCateogryLabel && alarmCateogryLabel.title)
                alarmCateogryLabel = alarmCateogryLabel.title;

              item.alarmCateogryLabel = alarmCateogryLabel;
            });

            response.entityData.securityAlarmConditions =
              response.entityData.securityAlarmConditions.filter(
                (item: any) => {
                  return item.alarmCateogryLabel;
                }
              );

            setTimeout(() => {
              loading.value = false;
            }, 350);

            module.value.securityalerts.component.options.rows =
              response.entityData.securityAlarmConditions;
            module.value.securityalerts.component.options.total =
              response.entityData.securityAlarmConditions.length;
          });
      }, 100);
    };

    onMounted(() => {
      getList();
    });

    let isEditing = () => {
      let rows = module.value.securityalerts.component.options.rows;
      let check = false;
      rows.forEach((row: any) => {
        if (row && row.alarmCateogryGuid) {
          if (row.alarmCateogryGuid === newAlertJson.value.selectedAlert) {
            check = true;
          }
        }
      });
      return check;
    };

    let getRow = (sel: string) => {
      let res = null;
      let rows = module.value.securityalerts.component.options.rows;
      rows.forEach((row: any) => {
        if (row && row.alarmCateogryGuid) {
          if (row.alarmCateogryGuid.trim() === sel.trim()) {
            res = row;
          }
        }
      });
      return res;
    };

    let selectAlert = (evt: any) => {
      let curRow = getRow(evt.target.value);
      if(curRow) {
        currCondId.value = curRow!["id"];
      }
    };

    const deleteFunction = function (id: any) {
      Swal.fire({
        title: "Are You Sure?",
        text: "You are about to delete the selected item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.isConfirmed) {
          store
            .dispatch(AlertActionTypes.REMOVE_CONDITION, id)
            .then((response: any) => {
              if (response.isSuccess) {
                getList();
              }
              if (Number(response.statusCode) != 200) {
                Swal.fire("Error", response.Errors, "error");
              } else {
                Swal.fire("Deleted!", "The Alert has been deleted.", "success");
              }
            })
            .catch((e: any) => {
              Swal.fire("Error", JSON.stringify(e.Message), "error");
            });
        }
      });
    };

    return {
      module,
      categorylist,
      deleteFunction,
      getList,
      newAlertJson,
      loading,
      isEditing,
      selectAlert,
      getRow,
      currCondId,
    };
  },
  data: () => ({
    emails: [] as string[],
    sendEmail: false,
    compKey: 0,
  }),
  methods: {
    async handleTagCreate(option: any, select$: any) {
      if (!option) {
        Swal.fire("Error", "Email is required", "error");
        setTimeout(() => {
          this.emails.pop();
          ++this.compKey;
        }, 300);
        return false;
      }

      const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      if (!regex.test(option)) {
        Swal.fire("Error", "This field must be a valid email", "error");
        setTimeout(() => {
          this.emails.pop();
          ++this.compKey;
        }, 300);
        return false;
      }

      return option;
    },
    addOrUpdateAlert(add = true) {
      if (this.emails.length === 0) {
        Swal.fire("Error", "Email is required and must be valid", "error");
        return;
      }
      let body = {
        alarmCateogryGuid: this.newAlertJson.selectedAlert,
        conditionJson: JSON.stringify(this.currentConditions),
        companyGuid: this.currentCompanyGuid,
        emails: this.emails,
        alarmType: 1,
        sendEmail: this.sendEmail,
        id: "",
      };
      if (!add) {
        body.id = this.currCondId;
      }

      //alert(JSON.stringify(body))
      let url = "";
      if (add) {
        url = "Alarm/CreateAlarmCondition";
      } else {
        url = "Alarm/UpdateCondition";
      }
      api.post(url, body).then((res) => {
        if (res && res.data.statusCode == 409) {
          Swal.fire({
            title: "Error",
            text: res.data.message,
            icon: "error",
            showCancelButton: false,
          });
        } else {
          this.getList();
        }
        this.newAlertJson.selectedAlert = "";
      });
    },
  },
});
